import { Component, ViewChildren, QueryList, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { AuthService } from "../../services/auth/auth.service";
import { Router, RouterOutlet } from "@angular/router";
import { to64decode, to64encode } from 'src/app/helpers/base64';
import { UserEnvironmentsService } from 'src/app/services/userEnvironments/user-environments.service';
import { getLanguageCookie, getLanguage } from 'src/assets/language';
import { UsersService } from "../../services/users/users.service";
import { cookieToJson, localStorageToJsonAsync } from "../../helpers/cookieToJson";
import { HomeService } from "../../services/home/home.service";
import { EditInstanceComponent } from 'src/app/components/modal/instance/edit-instance/edit-instance.component';
import { Subscription } from 'rxjs';
import { FunctionService } from 'src/app/services/function.service';
import { CorporationService } from 'src/app/services/corporation/corporation.service';
import { NavigationEnd } from '@angular/router';
import { NavigationService } from 'src/app/services/navigation/navigation.service';
import { TestBed } from '@angular/core/testing';
import { systemPermissionsNew } from 'src/app/helpers/systemPermissions';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss']
})
export class PagesComponent {
  @ViewChild('scrollTarget') scrollTarget!: ElementRef;

  static queueAlert: any = []
  static queueTime: any = []

  cards: any = {
    enterprise: [],
    environment: [],
    corporations: [],
    users: [],
    business_solutions: [],
  }

  corporationAccess: any = []

  fliped: string = '';
  flag = false;
  flagClickedIndicators: boolean = false;

  properties: any = {
    environment: {},
    corporation: {},
    language: { lang: 'en', file: 'us.svg'},
    me: {},
    token: null
  }

  selectedCorporation: any = { uuid: '', name: ''};
  corporation: any = {
    array: [],
    filteredArray: [{ uuid: '', name: ''}],
    search: '',
    tree: []
  }


  selectedItem!: string;

  selectedInstance: any = { uuid: '', name: ''};
  routerStateSnapshot: any = null
  parameters: any = {}

  isLoadingChooseInstance = false;

  me: any = {};
  instancesArray: any = [];
  instanceFilteredArray: any = []
  searchInstance! : string;
  lang = 'us'
  selectedFlag: any = { lang: 'en', file: 'us.svg' };
  flagArray: any = [
    { lang: 'en', file: 'us.svg'},
    { lang: 'pt', file: 'br.svg'}
  ]
  configArray: any = [
    { name: {en: 'Exit', pt: 'Sair'}, route: 'login', exit: true}
  ]
  configSystemArray: any = []
  selectedUser: any = { name: ''}
  intervalId: any = 0
  editInstance = EditInstanceComponent;
  @ViewChildren(RouterOutlet) routerOutlets!: QueryList<RouterOutlet>;

  menu: any = []
  displayedImage: any = null;
  showMenuType: string = ''

  isShowPricing: boolean = false;

  public routerPages: any

  private subscription: Subscription = new Subscription();

  isShowConfigurations: boolean = false

  service: string = ''

  constructor(
    public authService: AuthService,
    public router: Router,
    private userEnvironmentService: UserEnvironmentsService,
    private userService: UsersService,
    private homeService: HomeService,
    public sharedData: FunctionService,
    private cdr: ChangeDetectorRef,
    private corporationService: CorporationService,
    private navigationService: NavigationService,
  ) {
    this.routerPages = router
    this.authService.setCookieLanguage()

    // Listen to router events
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if(event?.urlAfterRedirects != '/pricing' && this.isShowPricing){
          this.handleUrlChange();
        }
      }
    });
  }

  async ngOnInit() {
    // await this.getMe();
    this.properties = { ...await localStorageToJsonAsync(), config: { is_login: false }, ...await localStorageToJsonAsync(true) }
    await this.getUserInstance()
    await this.getUserCorporations()
    await this.getCorporationTree()
    this.selectedInstance = this.properties.environment;
    this.selectedCorporation = this.properties.corporation;

    if (this.selectedCorporation?.label) {
      this.selectedCorporation.name = this.selectedCorporation?.label;
    }

    if (localStorage.getItem('image_corporation') !== null) {
      this.displayedImage = localStorage.getItem('image_corporation')
    }

    if(localStorage.getItem('flagIndicator') && localStorage.getItem('flagIndicator') != ''){
      this.flagClickedIndicators = true;
    }

    // Inscreve no evento de reload
    this.subscription.add(
      this.sharedData.reloadPages$.subscribe(() => {
        this.ngOnInit();
      })
    );
  }

  async ngAfterViewInit() {
    this.subscription = this.sharedData.getUserCorporation$.subscribe(() => {
      this.selectedCorporation = to64decode(localStorage.getItem('corporation'))
      if (localStorage.getItem('image_corporation') != null) {
        this.displayedImage = localStorage.getItem('image_corporation')
      }
      this.cdr.detectChanges(); 
    });

    this.subscription.add(this.sharedData.closeService$.subscribe(() => {
      this.handleUrlChange();
    }));
  }

  async getMe() {
    try {
      const response = await this.authService.getMe();
      if (![200].includes(response.status)) {
        return this.setAddAlert('danger', response.message)
      }

      this.properties = { ...response.data, ...await localStorageToJsonAsync(true) }
      localStorage.setItem('image_corporation', this.properties.corporation.url)
      delete this.properties.corporation.url
      await this.authService.setCookie(this.properties)
      await this.userService.setUserMe(this.properties)
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

  getLanguages(file: string){
    return getLanguageCookie(file, localStorage.getItem('language'))
  }

  getLanguageItem(item: any){
    return item[this.properties.language.lang]
  }

  getClassItem(item: any){
    return `fas icon ${item} `
  }

  showMenu(slug: string){
    this.showMenuType = slug
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  async getUserInstance(){
    try{
      let response = await this.userEnvironmentService.getUserEnvironmentsMe(this.properties.me.uuid)
      if( response && response.data){
        this.instancesArray = response.data;
        this.instanceFilteredArray = response.data
      }
    }catch{

    }
  }

  private cleanCorporationTree(tree: any[]): any[] {
    if (!Array.isArray(tree)) return [];

    return tree.map((node: any) => {
      const { name, uuid, url, children, slug, is_active, is_principal } = node;
      return {
        label: name,
        slug,
        uuid,
        url,
        expanded: true,
        is_active,
        is_principal,
        children: Array.isArray(children) ? this.cleanCorporationTree(children) : []
      };
    });
  }

  async getCorporationTree() {
    this.subscription.add(
      this.corporationService.getCorporationTree({ search: '' })
        .subscribe(
          async (response: any) => {
            if (response && response.data && response.data.result) { 
              this.corporation.tree = this.cleanCorporationTree(response.data.result);
              const flattened = this.flattenCorporationTree(response.data.result);
              this.corporation.array = flattened;
              this.corporation.filteredArray = this.corporation.array;

            } else {
              throw new Error('Erro ao consultar àrvore de corporations!\nConsulta o administrador do sistema!');
            }

          },
          (error: any) => {
            console.error(error);
          }
        )
    );
  }

  async getUserCorporations(){
    try{
      let response = await this.userEnvironmentService.getUserCorporations()
      if(response && response.data){
        this.corporationAccess = response.data;
      }
    }catch{

    }
  }

  async selectFlag(flag: any) {
    this.properties.language = flag;
     localStorage.setItem('language', to64encode(this.properties.language))
  }

  async chooseCorporation(corporation: any) {
    this.displayedImage = null;
    if (this.properties?.corporation?.uuid === corporation?.uuid || !corporation.access) {
      return;
    }
    localStorage.setItem('image_corporation', corporation.url);
    delete corporation.url;
    this.isLoadingChooseInstance = true;
    this.selectedCorporation = corporation;
    this.selectedItem = corporation;
    this.corporation.search = '';

    localStorage.removeItem('corporation');
    await this.authService.setCookie({corporation: corporation});

    await this.getMe();
  }

  onLoadingComplete() {
    this.isLoadingChooseInstance = false;
    
    // Verifica se tem permissão para a tela atual
    const currentRoute = this.router.url.split('/')[1];
    if (currentRoute && !this.getSystemPermission(currentRoute)) {
      this.navigationService.navigate('/');
      addAlert('danger', getLanguage('without_permission', this.properties.language.lang))
    } else {
      this.navigationService.reload();
    }
  }

  filterByArray(slug: string) {
    // if(slug == 'corporation'){
    //   this.corporation.filteredArray = this.corporation.array.filter((item : { name: string}) =>
    //   item?.name?.toLowerCase().includes(this.corporation.search.toLowerCase())
    //   )

    //   this.corporation.filteredArray = sortArrayOfObjects(this.corporation.filteredArray)
    // }
    if(slug == 'instance'){
      this.instanceFilteredArray = this.instancesArray.filter((item : { environment: {name: string} }) =>
        item.environment?.name?.toLowerCase().includes(this.searchInstance.toLowerCase())
      )
    }
  }

  navigate(route: string, exit: boolean = false) {
    if (exit) {
      if (this.sharedData.isChangeTree) {
        this.sharedData.isShowModalChangeTree = true;
        this.sharedData.route = route;
        return;
      }
  
      // Remove os itens do localStorage
      localStorage.removeItem('image_corporation');
  
      // Lista de chaves para manter
      const keepKeys = ['language'];
  
      // Remove todos os itens do localStorage, exceto aqueles na lista de chaves para manter
      Object.keys(localStorage).forEach(key => {
        if (!keepKeys.includes(key)) {
          localStorage.removeItem(key);
        }
      });
    }
  
    this.router.navigate([route]);
  }
  

  async chooseEnvironment(environment: any) {
   
    this.showMenuType = ''

    this.selectedInstance = environment;
    this.isLoadingChooseInstance = true;

    localStorage.removeItem('environment');
    localStorage.removeItem('corporation');
    localStorage.setItem('environment', to64encode(environment));
    this.selectedItem = this.selectedInstance;

    await this.getMe()
    await this.ngOnInit()

    setTimeout(() => {
      this.isLoadingChooseInstance = false;
      this.navigationService.reload()
    }, 2000);
  }

  getSystemPermission(screen: string, action?: string){
    return systemPermissionsNew(screen, action)
  }

  getName(name: string | undefined | null){
    if (name) {
        return name.substring(0, 2).toUpperCase();
    }
    return '';
  }

  async initCardEnterprise(){
    switch (this.router.url) {
      case '/business-solutions':
        this.fliped = 'business_solutions'
        break;
      case '/corporations':
        this.fliped = 'corporations'
        break;
      case '/users':
        this.fliped = 'users'
        break;
      case '/environments':
        this.fliped = 'environments'
        break;
      default:
        this.fliped = 'home'
        break;
    }
  }

  getCardArray(): any{
    return this.cards[this.fliped]
  }

  async getCardsArrays(){
    try {
      const response: any = await this.homeService.getCardsArrays(this.fliped).toPromise()
      if (response.data) {
        this.cards[this.fliped] = response.data
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

  async flipedCard(text: string) {
    this.fliped = text;
    // await this.getCardsArrays();

    this.flagClickedIndicators = true;
     localStorage.setItem('flagIndicator', to64encode({flag: 'true'}))
  }

  scrollScreen(event?: any) {
    // const scroolTarget = this.scrollTarget.nativeElement;
    //   if (scroolTarget) {
    //     scroolTarget.scrollIntoView({ behavior: 'smooth' });
    //   }
  }

  getIndicators(){
    if(this.router.url == '/activities' || this.router.url == '/environments'){
      return false
    }
    // if(this.router.url == '/' || this.router.url == '/home'){
    if(this.router.url == '/' || this.router.url == '/home'){

      return true
    }
    return this.flagClickedIndicators
  }

  navigationSideBar(event: any){
    this.initCardEnterprise()
    localStorage.removeItem('flagIndicator')
    this.flagClickedIndicators = false;
    // this.flipedCard('home')
    this.cards.enterprise.forEach((item: any) => {
      item.flip = false
    });
    this.fliped = 'home'
  }

  async getCards () {
    try {
      const response: any = await this.homeService.getCards(this.fliped).toPromise()
      if (response && response.data && response.data.cards) {
        this.cards.enterprise = response.data.cards
        // response.data.breed
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

  async setJobParameters () {
    await this.homeService.setJobParameters({ name: 'lpj-make-api by UI' })
  }

  toggleConfigurations(){
    this.isShowConfigurations = !this.isShowConfigurations
  }

  getQueueAlert (): any {
    return PagesComponent.queueAlert
  }

  getQueueTime () {
    return PagesComponent.queueTime
  }

  setAddAlert (type: string = '', text: string = '') {
    addAlert(type, text)
  }

  setRemoveAlert (id: number, event?: Event) {
    removeAlert(id, event)
  }

  protected readonly Object = Object;

  getIndentation(item: any, level: number = 0): number {
    let indentation = 0;
    let current = item;
  
    while (current?.parentUuid) {
      indentation += 20; // Valor da indentação por nível, ajustável
      current = this.findParentByUuid(current.parentUuid);
    }
  
    return indentation;
  }
  
  findParentByUuid(uuid: string): any {
    const findInChildren = (children: any[]): any | null => {
      for (const child of children) {
        if (child.uuid === uuid) {
          return child;
        }
  
        if (child.children && child.children.length > 0) {
          const result = findInChildren(child.children);
          if (result) {
            return result;
          }
        }
      }
      return null;
    };
  
    return findInChildren(this.corporation.array);
  }

  async swapShowService(event: any){
    this.service = event
    // this.isShowPricing = true
    await this.activatePricing()
    this.cdr.detectChanges();
  }  

  flattenCorporationTree(tree: any[], level: number = 1, result: any[] = []): any[] {
    for (const corporation of tree) {
      const corporationClone = { ...corporation, __level: level };
  
      if (this.properties?.me?.is_admin_master || this.corporationAccess.some((access: any) => access.uuid == corporationClone.uuid)) {
        corporationClone.access = true;
      } else {
        corporationClone.access = false;
      }
          
      result.push({ uuid: corporationClone.uuid, name: corporationClone.name, level: level, access: corporationClone.access, slug: corporationClone.slug });
  
      if (corporation.children && corporation.children.length > 0) {
        this.flattenCorporationTree(corporation.children, level + 1, result);
      }
    }
    return result;
  }

  async activatePricing(){
    this.isShowPricing = true
    this.router.navigate(['/pricing']);
    this.cdr.detectChanges();
  }

  async handleUrlChange() {
    this.isShowPricing = false;
  }
}


export function addAlert(type: string = '', text: string = '') {
  const someAlert = PagesComponent.queueAlert.find((alert: { text: string }) => alert.text === text);

  if (someAlert) {
    removeAlert(someAlert.id)
    clearTimeout(PagesComponent.queueTime[someAlert.id]);
  }

  PagesComponent.queueAlert.push({ id: PagesComponent.queueAlert.length, type, text })
  PagesComponent.queueTime[PagesComponent.queueAlert.length] = setTimeout(() => {
    removeAlert(PagesComponent.queueAlert.length)
  }, 3000)
}

export function removeAlert(id: number, event?: Event){
  PagesComponent.queueAlert.splice(PagesComponent.queueAlert.findIndex((item: {id: number;}) => item.id == id), 1)
}

export async function apiOfflineAsync (error: any) {
  if (!error.status) {
    return
  }

  let cookie = await localStorageToJsonAsync(true)

  if ([401, 511].includes(error.status) || ([500].includes(error.status) && error.error.error == 'jwt expired')) {
    if ([511].includes(error.status)) {
      addAlert('danger', getLanguage('errors/system/out', cookie['language']['lang']))
      return setTimeout(() => {
        return navigate('/login');
      }, 2000)
    }
    return navigate('/login');
  }

  addAlert(
    error.status == 0 ? 'danger' : 'orange',
    error.status == 0 ?
      getLanguage('errors/system/out', cookie['language']['lang']) :
      (error && error.error ? error.error.message: '')
  )
}

export function apiOffline (error: any) {
  let cookie = cookieToJson(true)

  if (!error.status) {
    return
  }

  if ([401, 511].includes(error.status)) {
    if ([511].includes(error.status)) {
      addAlert('danger', getLanguage('errors/system/out', cookie['language']['lang']))
      return setTimeout(() => {
        return navigate('/login');
      }, 2000)
    }
    return navigate('/login');
  }

  addAlert(
    error.status == 0 ? 'danger' : 'orange',
    error.status == 0 ?
      getLanguage('errors/system/out', cookie['language']['lang']) :
      (error && error.error && error.error.error ? error.error.error :
        (error.error.message ? error.error.message: ''))
  )
}

export function navigate(route: string) {
  const navigationService = TestBed.inject(NavigationService);
  navigationService.navigate(route);
}

export function setValueById (id: string, value: any = null) {
  if (id == '') return

  if (document && document.getElementById(id) != null) {
    // @ts-ignore
    document.getElementById(id).value = value
  }
}




